import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getCategoryList } from "../../../services/Inventory/inventory"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const Category = ({
  control,
  name,
  onSelectChange,
  disabled,
  target,
  placeholder,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  const loadOptions = async () => {
    const data = await getCategoryList()
    setIsLoading(false)
    const response = data?.data?.map(dta => {
      return {
        label: dta?.category_code && ucfirst(dta.category_code),
        value: dta.id,
        ...dta,
      }
    })

    setFetchResponse(response)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Category Code"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Category Code"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disabled}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(target)}
            />
          )
        }}
      />
    </div>
  )
}

export default Category
